import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, Observable } from 'rxjs';
import { map, shareReplay, startWith, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class VersionService {
    private readonly VERSION_CHECK_INTERVAL = 1000 * 60 * 5;
    private readonly VERSION_URL = 'assets/version.json';

    private version$ = interval(this.VERSION_CHECK_INTERVAL).pipe(
        startWith(0),
        switchMap(() => this.http.get<{version: string}>(this.VERSION_URL)),
        map(response => response.version),
        shareReplay(1)
    );

    constructor(private http: HttpClient) {
        this.checkVersion();
    }

    private checkVersion() {
        let initialVersion: string | null = null;

        this.version$.subscribe(version => {
            if (initialVersion === null) {
                initialVersion = version;
            } else if (version !== initialVersion) {
                // Version changed, reload the application
                window.location.reload();
            }
        });
    }

    public getCurrentVersion(): Observable<string> {
        return this.version$;
    }
}